import React from 'react';
import { FaPhone, FaWhatsapp } from 'react-icons/fa';
import { PHONE, PHONE_HREF, WHATSAPP_HREF } from '../site';
import { track } from '../analytics';

const Footer = () => (
  <footer className="mt-auto border-t border-navy/10 bg-navy text-white">
    <div className="mx-auto flex max-w-6xl flex-col items-center gap-3 px-6 py-8 sm:flex-row sm:justify-between">
      <p className="font-semibold">Velocity Learning</p>

      <div className="flex flex-col items-center gap-2 sm:flex-row sm:gap-6">
        <a href={PHONE_HREF} onClick={() => track('Contact')} className="flex items-center gap-2 hover:underline">
          <FaPhone aria-hidden="true" /> {PHONE}
        </a>
        <a
          href={WHATSAPP_HREF}
          target="_blank"
          rel="noreferrer"
          onClick={() => track('Contact')}
          className="flex items-center gap-2 hover:underline"
        >
          <FaWhatsapp aria-hidden="true" /> WhatsApp
        </a>
      </div>

      <p className="text-sm text-white/70">
        &copy; {new Date().getFullYear()} Velocity Learning
      </p>
    </div>
  </footer>
);

export default Footer;
